import store from 'index'
import { signOut } from 'helpers/cookie.helpers'
import { openErrorToaster } from 'helpers/toaster.helpers'
import { getTranslation } from 'helpers/translations.helpers'
import errorMessages from 'network/messages/errorMessages'

// Dispatch by type to avoid circular import: auth.slice → auth.thunk → network → error.handler → here
const SESSION_EXPIRED_ACTION = 'authSlice/sessionExpired'

const SESSION_INVALID_MESSAGES = [
  'your session has timed out',
  'user session is not valid',
  'either access token not passed or it is expired',
  'invalid token',
  'unauthorized'
]

let isHandlingSessionExpiry = false

export const isSessionInvalidMessage = (message = '') => {
  const normalized = String(message).trim().toLowerCase()
  if (!normalized) return false
  return SESSION_INVALID_MESSAGES.some((fragment) => normalized.includes(fragment))
}

export const handleSessionExpired = ({ showToast = true } = {}) => {
  if (isHandlingSessionExpiry) return
  isHandlingSessionExpiry = true

  signOut()
  store.dispatch({ type: SESSION_EXPIRED_ACTION })

  if (showToast) {
    openErrorToaster({ message: getTranslation(errorMessages.unAuthorized) })
  }

  window.setTimeout(() => {
    isHandlingSessionExpiry = false
  }, 1000)
}
